const e = "Text alternative", n = "Font background color", t = "Bold", i = "Bulleted list", a = "Caption", o = "Decrease indent", r = "Default", s = "Paragraph spacing", l = "Font color", g = { adaptive: "Adaptive", adaptive_hint: "Ideal for a modern newsletter look. It uses a prioritized list of fonts (e.g., SF Pro, Roboto) and applies the first one available on the recipient's device", default: "Default", default_hint: "Uses the font set at the place of usage", hint: "Standard font uses email client fonts", mailbox_default: "Mailbox Default", mailbox_default_hint: "Ideal for a native inbox experience. Your message uses the default font of the recipient's email app (e.g., Gmail or Outlook), so it looks natural and blends into the inbox", title: "Font family" }, _ = "Font size", c = { apply: "Apply", clear: "Clear", error: "Error" }, u = "Image", d = "Centered image", m = "Change image text alternative", h = "Change image caption", p = "Change image link", k = "Set the image width to the full width of the mobile device", b = "Failed to process the image", f = "In line", q = "Insert image via link", v = "Side image", x = "Image via link", y = "Increase indent", w = "Italic", C = "Line hight", S = "Link", I = "Numbered list", D = "Redo", L = { austral: "Austral sign", bitcoin: "Bitcoin sign", cedi: "Cedi sign", cent: "Cent sign", colon: "Colon sign", copyright_sign: "Copyright sign", cruzeiro: "Cruzeiro sign", currency: "Currency sign", dollar: "Dollar sign", dong: "Dong sign", double_dagger: "Double dagger", double_exclamation_mark: "Double exclamation mark", double_low_quotation_mark: "Double low-9 quotation mark", double_question_mark: "Double question mark", drachma: "Drachma sign", euro: "Euro sign", euro_currency: "Euro-currency sign", exclamation_question_mark: "Exclamation question mark", french_franc: "French franc sign", german_penny: "German penny sign", guarani: "Guarani sign", horizontal_ellipsis: "Horizontal ellipsis", hryvnia: "Hryvnia sign", indian_rupee: "Indian rupee sign", inverted_exclamation_mark: "Inverted exclamation mark", inverted_question_mark: "Inverted question mark", kip: "Kip sign", left_double_quotation_mark: "Left double quotation mark", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", lira: "Lira sign", livre_tournois: "Livre tournois sign", manat: "Manat sign", mill: "Mill sign", new_sheqel: "New sheqel sign", nordic_mark: "Nordic mark sign", paragraph_sign: "Paragraph sign", per_mille_sign: "Per mille sign", per_ten_thousand_sign: "Per ten thousand sign", peseta: "Peseta sign", peso: "Peso sign", pound: "Pound sign", question_exclamation_mark: "Question exclamation mark", registered_sign: "Registered sign", reversed_paragraph_sign: "Reversed paragraph sign", right_double_quotation_mark: "Right double quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", right_single_quotation_mark: "Right single quotation mark", ruble: "Ruble sign", rupee: "Rupee sign", section_sign: "Section sign", select_all: "All", select_currency: "Currency", select_text: "Text", single_low_quotation_mark: "Single low-9 quotation mark", spesmilo: "Spesmilo sign", tenge: "Tenge sign", title: "Special characters", trade_mark_sign: "Trade mark sign", tugrik: "Tugrik sign", turkish_lira: "Turkish lira sign", two_dot_leader: "Two dot leader", won: "Won sign", yen: "Yen sign" }, P = "Strikethrough", R = "Substitute variables", z = "Substitutions", T = "Text alignment", F = { header_one: "Header 1", header_three: "Header 3", header_two: "Header 2", paragraph: "Paragraph", title: "Heading" }, H = "Underline", A = "Undo", E = "Unset", U = {
  alt_text: e,
  background_color: n,
  bold: t,
  bulletList: i,
  caption: a,
  decrease_intent: o,
  default_font_size: r,
  extra_spacing: s,
  font_color: l,
  font_family: g,
  font_size: _,
  global: c,
  image: u,
  image_center: d,
  image_change_alt_text: m,
  image_change_caption: h,
  image_change_link: p,
  image_change_mobile_full_width: k,
  image_error: b,
  image_in_line: f,
  image_insert_via_link: q,
  image_side: v,
  image_via_link: x,
  increase_intent: y,
  italic: w,
  line_height: C,
  link: S,
  orderedList: I,
  redo: D,
  special_characters: L,
  strike: P,
  substitute_variables: R,
  substitutions: z,
  text_align: T,
  text_level: F,
  underline: H,
  undo: A,
  unset: E
};
export {
  e as alt_text,
  n as background_color,
  t as bold,
  i as bulletList,
  a as caption,
  o as decrease_intent,
  U as default,
  r as default_font_size,
  s as extra_spacing,
  l as font_color,
  g as font_family,
  _ as font_size,
  c as global,
  u as image,
  d as image_center,
  m as image_change_alt_text,
  h as image_change_caption,
  p as image_change_link,
  k as image_change_mobile_full_width,
  b as image_error,
  f as image_in_line,
  q as image_insert_via_link,
  v as image_side,
  x as image_via_link,
  y as increase_intent,
  w as italic,
  C as line_height,
  S as link,
  I as orderedList,
  D as redo,
  L as special_characters,
  P as strike,
  R as substitute_variables,
  z as substitutions,
  T as text_align,
  F as text_level,
  H as underline,
  A as undo,
  E as unset
};
